import { createRouter, createWebHashHistory } from 'vue-router';
import { getContactVerified, getUserEmail } from '../utils/auth';

import LandingPage from '../LandingPage.vue';
import AccessForm from '../AccessForm.vue';
import ContactsList from '../ContactsList.vue';
import VerificationCode from '../VerificationCode.vue';

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      component: LandingPage,
    },
    {
      path: '/access-form',
      component: AccessForm,
    },
    {
      path: '/contacts-list',
      component: ContactsList,
    },
    {
      path: '/verification-code',
      component: VerificationCode,
    },
  ],
});

router.beforeEach((to) => {
  if (to.path === '/contacts-list' && (!getUserEmail() || !getContactVerified())) {
    return '/';
  }

  if (to.path === '/access-form' && getUserEmail()) {
    return getContactVerified() ? '/contacts-list' : '/verification-code';
  }

  if (to.path === '/verification-code' && !getUserEmail()) {
    return '/';
  }

  if (to.path === '/verification-code' && getContactVerified()) {
    return '/contacts-list';
  }

  return true;
});

export default router;
